export const fileJson =
    [
        {
            title: "immaginalo",
            img: "1.png",
            desc: "identifica il percorso"
        },
        {
            title: "codificalo",
            img: "7.png",
            desc: "Sabilisci e risolvi il problema"
        },
        {
            title: "sviluppalo",
            img: "4.png",
            desc: "Implementa la codifica del codice"
        }
    ]

export const main_title = {title: "approccio alla programmazione"}

